import { Routes } from '@angular/router';
import { HomeComponent } from './core/components/home/home.component';
import { LocalComponent } from './features/configuracoes/local/local.component';
import { FaseComponent } from './features/configuracoes/fase/fase.component';
import { RecebimentoComponent } from './features/recebimento/recebimento.component';
import { PainelComponent } from './features/painel/painel.component';
import { LcbFilaSegurancaComponent } from './features/fila/lcb/lcb-fila-seguranca/lcb-fila-seguranca.component';
import { SlaFilaFiscalComponent } from './features/fila/sla/sla-fila-fiscal/sla-fila-fiscal.component';
import { SlaFilaProdutivoComponent } from './features/fila/sla/sla-fila-produtivo/sla-fila-produtivo.component';
import { SlaFilaImprodutivoComponent } from './features/fila/sla/sla-fila-improdutivo/sla-fila-improdutivo.component';
import { LcbFilaProdutivoComponent } from './features/fila/lcb/lcb-fila-produtivo/lcb-fila-produtivo.component';
import { LcbFilaEmbalagemComponent } from './features/fila/lcb/lcb-fila-embalagem/lcb-fila-embalagem.component';
import { SlaFilaSegurancaComponent } from './features/fila/sla/sla-fila-seguranca/sla-fila-seguranca.component';
import { ControlPassComponent } from './features/control-pass/control-pass.component';
import { authGuard } from './core/guards/auth.guard';
import { IdentificacaoComponent } from './features/biometria/identificacao-motorista/identificacao.component';
import { ROLES } from './shared/enums/roles.enum';
import { TotemComponent } from './features/totem/totem.component';
import { BiometriaComponent } from './features/totem/biometria/biometria.component';
import { totemLocalGuard } from './core/guards/totem-local.guard';
import { CadastroMotoristaComponent } from './features/biometria/cadastro-motorista/cadastro-motorista.component';

export const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [authGuard] },
  {
    path: 'configuracao/locais',
    component: LocalComponent,
    canActivate: [authGuard],
    data: {
      requiredRoles: [ROLES.Administrator, ROLES.ScaniaIT],
    },
  },
  {
    path: 'configuracao/fases',
    component: FaseComponent,
    canActivate: [authGuard],
    data: {
      requiredRoles: [ROLES.Administrator, ROLES.ScaniaIT],
    },
  },
  {
    path: 'recebimentos',
    component: RecebimentoComponent,
    canActivate: [authGuard],
    data: {
      requiredRoles: [
        ROLES.Administrator,
        ROLES.ScaniaIT,
        ROLES.InspectorSLA,
        ROLES.GeneralUserLCB,
        ROLES.GeneralUserSLA,
        ROLES.SecurityLCB,
        ROLES.SecuritySLA,
      ],
    },
  },
  {
    path: 'filas/sla-seguranca',
    component: SlaFilaSegurancaComponent,
    canActivate: [authGuard],
    data: {
      requiredRoles: [ROLES.Administrator, ROLES.ScaniaIT, ROLES.SecuritySLA],
    },
  },
  {
    path: 'filas/sla-fiscal',
    component: SlaFilaFiscalComponent,
    canActivate: [authGuard],
    data: {
      requiredRoles: [
        ROLES.Administrator,
        ROLES.ScaniaIT,
        ROLES.InspectorSLA,
        ROLES.GeneralUserSLA,
      ],
    },
  },
  {
    path: 'filas/sla-diretos',
    component: SlaFilaProdutivoComponent,
    canActivate: [authGuard],
    data: {
      requiredRoles: [
        ROLES.Administrator,
        ROLES.ScaniaIT,
        ROLES.GeneralUserSLA,
      ],
    },
  },
  {
    path: 'filas/sla-indiretos',
    component: SlaFilaImprodutivoComponent,
    canActivate: [authGuard],
    data: {
      requiredRoles: [
        ROLES.Administrator,
        ROLES.ScaniaIT,
        ROLES.GeneralUserSLA,
      ],
    },
  },
  {
    path: 'filas/lcb-seguranca',
    component: LcbFilaSegurancaComponent,
    canActivate: [authGuard],
    data: {
      requiredRoles: [ROLES.Administrator, ROLES.ScaniaIT, ROLES.SecurityLCB],
    },
  },
  {
    path: 'filas/lcb-produtivo',
    component: LcbFilaProdutivoComponent,
    canActivate: [authGuard],
    data: {
      requiredRoles: [
        ROLES.Administrator,
        ROLES.ScaniaIT,
        ROLES.GeneralUserLCB,
      ],
    },
  },
  {
    path: 'filas/lcb-embalagem',
    component: LcbFilaEmbalagemComponent,
    canActivate: [authGuard],
    data: {
      requiredRoles: [
        ROLES.Administrator,
        ROLES.ScaniaIT,
        ROLES.GeneralUserLCB,
      ],
    },
  },
  {
    path: 'painel',
    component: PainelComponent,
    canActivate: [authGuard],
    data: {
      requiredRoles: [
        ROLES.Administrator,
        ROLES.ScaniaIT,
        ROLES.InspectorSLA,
        ROLES.GeneralUserLCB,
        ROLES.GeneralUserSLA,
        ROLES.SecurityLCB,
        ROLES.SecuritySLA,
      ],
    },
  },
  {
    path: 'control-pass',
    component: ControlPassComponent,
    canActivate: [authGuard],
    data: {
      requiredRoles: [
        ROLES.Administrator,
        ROLES.ScaniaIT,
        ROLES.InspectorSLA,
        ROLES.GeneralUserLCB,
        ROLES.GeneralUserSLA,
        ROLES.SecurityLCB,
        ROLES.SecuritySLA,
      ],
    },
  },
  {
    path: 'biometria/cadastro',
    component: CadastroMotoristaComponent,
    canActivate: [authGuard],
    data: {
      requiredRoles: [
        ROLES.Administrator,
        ROLES.ScaniaIT,
        ROLES.InspectorSLA,
        ROLES.GeneralUserLCB,
        ROLES.GeneralUserSLA,
        ROLES.SecurityLCB,
        ROLES.SecuritySLA,
      ],
    },
  },
  {
    path: 'biometria/identificacao',
    component: IdentificacaoComponent,
    canActivate: [authGuard],
    data: {
      requiredRoles: [
        ROLES.Administrator,
        ROLES.ScaniaIT,
        ROLES.InspectorSLA,
        ROLES.GeneralUserLCB,
        ROLES.GeneralUserSLA,
        ROLES.SecurityLCB,
        ROLES.SecuritySLA,
      ],
    },
  },
  {
    path: 'totem',
    redirectTo: 'totem/home',
    pathMatch: 'full',
  },
  {
    path: 'totem/home',
    component: TotemComponent,
    canActivate: [authGuard, totemLocalGuard],
    data: {
      requiredRoles: [
        ROLES.Administrator,
        ROLES.ScaniaIT,
        ROLES.InspectorSLA,
        ROLES.GeneralUserLCB,
        ROLES.GeneralUserSLA,
        ROLES.SecurityLCB,
        ROLES.SecuritySLA,
      ],
    },
  },
  {
    path: 'totem/biometria',
    component: BiometriaComponent,
    canActivate: [authGuard],
    data: {
      requiredRoles: [
        ROLES.Administrator,
        ROLES.ScaniaIT,
        ROLES.InspectorSLA,
        ROLES.GeneralUserLCB,
        ROLES.GeneralUserSLA,
        ROLES.SecurityLCB,
        ROLES.SecuritySLA,
      ],
    },
  },
];
